export const CHART_PATTERNS_GROUP_NAME = 'Chart Patterns'
export const CANDLESTICK_PATTERNS_GROUP_NAME = 'Candlestick Patterns'

/** Top-level indicator dialog group — merges chart + candlestick pattern indicators */
export const PATTERNS_GROUP_NAME = 'Patterns'

export const PATTERN_SUBCATEGORY_CHART = CHART_PATTERNS_GROUP_NAME
export const PATTERN_SUBCATEGORY_CANDLESTICK = CANDLESTICK_PATTERNS_GROUP_NAME

/** TradingView-style subheaders inside the Patterns tab */
export const PATTERN_SUBHEADER_CHART = 'CHART PATTERNS'
export const PATTERN_SUBHEADER_CANDLESTICK = 'CANDLESTICK PATTERNS'

export const PATTERN_SUBCATEGORIES = [
    PATTERN_SUBCATEGORY_CHART,
    PATTERN_SUBCATEGORY_CANDLESTICK,
] as const

export const PATTERN_GROUP_NAMES = [
    CHART_PATTERNS_GROUP_NAME,
    CANDLESTICK_PATTERNS_GROUP_NAME,
    PATTERNS_GROUP_NAME,
] as const

export function isPatternGroupName(groupName?: string): boolean {
    return groupName === CHART_PATTERNS_GROUP_NAME
        || groupName === CANDLESTICK_PATTERNS_GROUP_NAME
        || groupName === PATTERNS_GROUP_NAME
}

export function toDisplayIndicatorGroupName(groupName: string): string {
    if (groupName === CHART_PATTERNS_GROUP_NAME || groupName === CANDLESTICK_PATTERNS_GROUP_NAME) {
        return PATTERNS_GROUP_NAME
    }
    return groupName
}

export function getPatternSubheader(groupName: string): string | undefined {
    if (groupName === CHART_PATTERNS_GROUP_NAME) return PATTERN_SUBHEADER_CHART
    if (groupName === CANDLESTICK_PATTERNS_GROUP_NAME) return PATTERN_SUBHEADER_CANDLESTICK
    return undefined
}

export type PatternSubcategory = (typeof PATTERN_SUBCATEGORIES)[number]
